import api from "./api";

export const createWarehouseZone = async (payload) => {
    const response = await api.post("/warehousezone", {
        warehouseId: Number(payload.warehouseId),
        name: payload.name?.trim() || "",
        zoneType: payload.zoneType?.trim() || "Storage",
        description: payload.description?.trim() || null,
        capacity: Number(payload.capacity),
        requiresTemperatureControl:
            Boolean(payload.requiresTemperatureControl),
        minTemperatureCelsius:
            payload.requiresTemperatureControl &&
                payload.minTemperatureCelsius !== "" &&
                payload.minTemperatureCelsius !== null &&
                payload.minTemperatureCelsius !== undefined
                ? Number(payload.minTemperatureCelsius)
                : null,
        maxTemperatureCelsius:
            payload.requiresTemperatureControl &&
                payload.maxTemperatureCelsius !== "" &&
                payload.maxTemperatureCelsius !== null &&
                payload.maxTemperatureCelsius !== undefined
                ? Number(payload.maxTemperatureCelsius)
                : null,
    });

    return response.data;
};

export const getWarehouseZones = async () => {
    const response = await api.get("/warehousezone");

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const getWarehouseZoneById = async (id) => {
    const zoneId = Number(id);

    if (!Number.isInteger(zoneId) || zoneId <= 0) {
        throw new Error(
            "Warehouse zone ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehousezone/${zoneId}`
    );

    return response.data;
};

export const getWarehouseZonesByWarehouse = async (
    warehouseId
) => {
    const id = Number(warehouseId);

    if (!Number.isInteger(id) || id <= 0) {
        throw new Error(
            "Warehouse ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehousezone/warehouse/${id}`
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const updateWarehouseZone = async (
    id,
    payload
) => {
    const zoneId = Number(id);

    if (!Number.isInteger(zoneId) || zoneId <= 0) {
        throw new Error(
            "Warehouse zone ID must be a positive integer."
        );
    }

    const response = await api.put(
        `/warehousezone/${zoneId}`,
        {
            name: payload.name?.trim() || "",
            zoneType:
                payload.zoneType?.trim() || "Storage",
            description:
                payload.description?.trim() || null,
            capacity: Number(payload.capacity),
            requiresTemperatureControl:
                Boolean(
                    payload.requiresTemperatureControl
                ),
            minTemperatureCelsius:
                payload.requiresTemperatureControl &&
                    payload.minTemperatureCelsius !== "" &&
                    payload.minTemperatureCelsius !== null &&
                    payload.minTemperatureCelsius !== undefined
                    ? Number(
                        payload.minTemperatureCelsius
                    )
                    : null,
            maxTemperatureCelsius:
                payload.requiresTemperatureControl &&
                    payload.maxTemperatureCelsius !== "" &&
                    payload.maxTemperatureCelsius !== null &&
                    payload.maxTemperatureCelsius !== undefined
                    ? Number(
                        payload.maxTemperatureCelsius
                    )
                    : null,
            isActive:
                payload.isActive !== false,
        }
    );

    return response.data;
};

export const deactivateWarehouseZone = async (id) => {
    const zoneId = Number(id);

    if (!Number.isInteger(zoneId) || zoneId <= 0) {
        throw new Error(
            "Warehouse zone ID must be a positive integer."
        );
    }

    const response = await api.patch(
        `/warehousezone/${zoneId}/deactivate`
    );

    return response.data;
};

const warehouseZoneService = {
    createWarehouseZone,
    getWarehouseZones,
    getWarehouseZoneById,
    getWarehouseZonesByWarehouse,
    updateWarehouseZone,
    deactivateWarehouseZone,
};

export default warehouseZoneService;